import { createBrowserRouter, Navigate, Outlet } from "react-router";
import { isLoggedIn } from "@/lib/auth";
import { AppShell } from "@/components/AppShell";
import { Login } from "@/routes/Login";
import { Dashboard } from "@/routes/Dashboard";
import { Signals } from "@/routes/Signals";
import { SignalDetail } from "@/routes/SignalDetail";
import { Trades } from "@/routes/Trades";
import { NewTrade } from "@/routes/NewTrade";
import { Channels } from "@/routes/Channels";
import { ChannelDetail } from "@/routes/ChannelDetail";
import { Accounts } from "@/routes/Accounts";
import { Settings } from "@/routes/Settings";
import { Reports } from "@/routes/Reports";
import { SelfTrader } from "@/routes/SelfTrader";
import { Notifications } from "@/routes/Notifications";
import { NotificationPreferences } from "@/routes/NotificationPreferences";

/**
 * Re-evaluated on every navigation (it's a component, not a one-time check), so a token
 * cleared by api.ts's 401 handler or the shell's logout button takes effect on the very
 * next route change rather than requiring a reload.
 */
function RequireAuth() {
  if (!isLoggedIn()) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: "/", element: <Dashboard /> },
          { path: "/signals", element: <Signals /> },
          { path: "/signals/:id", element: <SignalDetail /> },
          { path: "/trades", element: <Trades /> },
          { path: "/trade/new", element: <NewTrade /> },
          { path: "/channels", element: <Channels /> },
          { path: "/channels/:id", element: <ChannelDetail /> },
          { path: "/reports", element: <Reports /> },
          { path: "/self-trader", element: <SelfTrader /> },
          { path: "/accounts", element: <Accounts /> },
          { path: "/notifications", element: <Notifications /> },
          { path: "/notifications/settings", element: <NotificationPreferences /> },
          { path: "/settings", element: <Settings /> },
        ],
      },
    ],
  },
]);
